module.exports = __webpack_public_path__ + "img/join_about.65a9bdad.png";